module.exports = __webpack_public_path__ + "img/mith.7f0d7cfc.svg";